<template>
    <!-- Varify variant: CSS reserves the column from the first paint, the content mounts client-only on desktop. -->
    <aside v-if="hasInlineFilterColumn" class="hidden lg:shrink-0 lg:basis-88 varify-inline-filters:lg:block" data-test-id="inline-filters">
        <template v-if="isInlineFilters && categorySearch.isDesktopViewport.value">
            <CategoryListerPageDescription :description="listerPageDescription" />

            <div class="lg:sticky lg:top-4 lg:flex lg:max-h-[calc(100dvh-2rem)] lg:flex-col lg:overflow-hidden">
                <CategoryLinksSidebar v-if="!categorySearch.hideCategoryLinksOnDesktop.value" :links="categorySearch.categoryLinks.value" />

                <div v-if="hasDesktopFilters" class="flex min-h-0 flex-1 flex-col rounded-lg bg-gray-50 [--filter-surface:var(--color-gray-50)]">
                    <CategorySearchFiltersContent
                        sidebar
                        :viewport="CategoryFilterViewport.Desktop"
                        :filter-panels="categorySearch.desktopFilterPanels.value"
                        :selected-filter-counts="selectedFilterCounts"
                        :collection-filter-attribute="categorySearch.collectionFilterAttribute"
                        :default-facet-value-limit="categorySearch.defaultFacetValueLimit"
                        :default-show-more-limit="categorySearch.defaultShowMoreLimit"
                        :on-filter-applied="categorySearch.handleDesktopFilterApplied"
                    />
                </div>
            </div>
        </template>
    </aside>
</template>

<script lang="ts" setup>
import { CategoryFilterViewport } from '@/composables/category/CategoryFilterViewport';
import type { useCategorySearch } from '@/composables/category/useCategorySearch';
import { useVarifyInlineFilters } from '@/composables/category/useVarifyInlineFilters';
import { textCategoryLinks } from '@/lib/category/categoryLinks';
import CategoryLinksSidebar from '@/pages/category/partials/CategoryLinksSidebar.vue';
import CategoryListerPageDescription from '@/pages/category/partials/CategoryListerPageDescription.vue';
import CategorySearchFiltersContent from '@/pages/category/partials/CategorySearchFiltersContent.vue';
import { computed } from 'vue';

const props = defineProps<{
    categorySearch: ReturnType<typeof useCategorySearch>;
    listerPageDescription: string | undefined;
    selectedFilterCounts: Record<string, number>;
}>();

const isInlineFilters = useVarifyInlineFilters();

const hasDesktopFilters = computed(
    (): boolean => props.categorySearch.productStore.filtersEnabled && props.categorySearch.desktopFilterPanels.value.length > 0,
);

// Before Algolia reports facets this is the configured desktop list, so the column is reserved from the first render.
const hasInlineFilterColumn = computed((): boolean => {
    const hasTextLinks =
        !props.categorySearch.hideCategoryLinksOnDesktop.value && textCategoryLinks(props.categorySearch.categoryLinks.value).length > 0;

    return hasTextLinks || hasDesktopFilters.value;
});
</script>
